<template>
  <div class="relative my-8 max-w-screen-sm mx-auto">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'PageContainer',
}
</script>